var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { SCORECARD_TAGS } from "../common.js";
import { xCardScorecardApi } from "../api.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
const xCardQualityWarningHooks = xCardScorecardApi.injectEndpoints({
  endpoints: (builder) => ({
    getQualityWarnings: builder.query({
      query: ({ payload, workspaceId }) => {
        return {
          url: EnvironmentService.callXCardApiCommonInfra() ? `/workspaces/${workspaceId}/qualityWarnings` : `/qualityWarnings`,
          body: payload,
          method: "POST"
        };
      },
      providesTags: (result, error, payload) => [__spreadValues({ type: SCORECARD_TAGS.XCARD_QUALITY_WARNINGS }, payload)]
    })
  })
});
const { usePrefetch: useQualityWarningsApiPrefetch, useGetQualityWarningsQuery } = xCardQualityWarningHooks;
export {
  useGetQualityWarningsQuery,
  useQualityWarningsApiPrefetch,
  xCardQualityWarningHooks
};
//# sourceMappingURL=quality-warnings.js.map
